module.exports = __webpack_public_path__ + "static/img/home_bj.61b4042f.jpg";